import React, { useEffect } from "react";
import './lightbox.css';

function Lightbox({ image, onClose, onPrev, onNext }) {
  useEffect(() => {
    if (!image) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      } else if (event.key === "ArrowLeft" && onPrev) {
        onPrev();
      } else if (event.key === "ArrowRight" && onNext) {
        onNext();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    };
  }, [image, onClose, onPrev, onNext]);

  if (!image) {
    return null;
  }

  return (
    <div
      className="lightbox"
      role="dialog"
      aria-modal="true"
      aria-label={image.alt}
      onClick={onClose}
    >
      <button
        type="button"
        className="lightbox__close"
        onClick={onClose}
        aria-label="Fechar"
      >
        &times;
      </button>

      {onPrev && (
        <button
          type="button"
          className="lightbox__nav lightbox__nav--prev"
          onClick={(event) => { event.stopPropagation(); onPrev(); }}
          aria-label="Imagem anterior"
        >
          &#8249;
        </button>
      )}

      <img
        className="lightbox__image"
        src={image.src}
        alt={image.alt}
        onClick={(event) => event.stopPropagation()}
      />

      {onNext && (
        <button
          type="button"
          className="lightbox__nav lightbox__nav--next"
          onClick={(event) => { event.stopPropagation(); onNext(); }}
          aria-label="Próxima imagem"
        >
          &#8250;
        </button>
      )}
    </div>
  );
}

export default Lightbox;
